import React, { ChangeEvent, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  CardMedia,
  FormControlLabel,
  Input,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import CloseIcon from "@mui/icons-material/Close";
import "react-phone-input-2/lib/bootstrap.css";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

const AddEditDealer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAddUser = location.pathname === "/manage-dealers/add";

  const [showroomImage, setShowroomImage] = useState<string>("");
  const [logo, setLogo] = useState<string>("");

  return (
    <>
      {/* PAGE TITLE */}
      <div className="main_title">
        <h1>{isAddUser ? "Add" : "Edit"} Dealer</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-dealers")}>
            Dealers Management
          </button>{" "}
          - {isAddUser ? "Add" : "Edit"} Dealer
        </p>
      </div>

      <div className="form">
        <div className="cards">
          <div className="table_header">
            <h2>Showroom Information</h2>
          </div>
          <div className="gap_p">
            {/* Showroom Image Upload */}
            <div className="control_group w_100">
              <label>Showroom Image</label>
              <div className="gap_p">
                <div className="w_25">
                  {showroomImage ? (
                    <div className="upload_image no_radius v2">
                      <div className="upload_image_holder">
                        <figure>
                          <CardMedia component="img" image={showroomImage} />
                        </figure>
                        <CloseIcon
                          className="remove_img"
                          onClick={() => setShowroomImage("")}
                        />
                      </div>
                    </div>
                  ) : (
                    <label className="upload_image no_radius v2">
                      <Input
                        sx={{ display: "none" }}
                        type="file"
                        inputProps={{ accept: "image/*" }}
                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                          const files = event.target.files;
                          if (files && files[0]) {
                            setShowroomImage(URL.createObjectURL(files[0]));
                          }
                        }}
                      />
                      <span className="upload_image_holder">
                        <figure className="add_img">
                          <img src="/static/images/placeholder.png" alt="" />
                          <span className="upload_img_icon">
                            <img src="/static/images/edit2_icon.svg" alt="" />
                          </span>
                        </figure>
                      </span>
                    </label>
                  )}
                </div>
                <div className="w_25">
                  {showroomImage ? (
                    <div className="upload_image no_radius v2">
                      <div className="upload_image_holder">
                        <figure>
                          <CardMedia component="img" image={showroomImage} />
                        </figure>
                        <CloseIcon
                          className="remove_img"
                          onClick={() => setShowroomImage("")}
                        />
                      </div>
                    </div>
                  ) : (
                    <label className="upload_image no_radius v2">
                      <Input
                        sx={{ display: "none" }}
                        type="file"
                        inputProps={{ accept: "image/*" }}
                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                          const files = event.target.files;
                          if (files && files[0]) {
                            setShowroomImage(URL.createObjectURL(files[0]));
                          }
                        }}
                      />
                      <span className="upload_image_holder">
                        <figure className="add_img">
                          <img src="/static/images/placeholder.png" alt="" />
                          <span className="upload_img_icon">
                            <img src="/static/images/edit2_icon.svg" alt="" />
                          </span>
                        </figure>
                      </span>
                    </label>
                  )}
                </div>
                <div className="w_25">
                  {showroomImage ? (
                    <div className="upload_image no_radius v2">
                      <div className="upload_image_holder">
                        <figure>
                          <CardMedia component="img" image={showroomImage} />
                        </figure>
                        <CloseIcon
                          className="remove_img"
                          onClick={() => setShowroomImage("")}
                        />
                      </div>
                    </div>
                  ) : (
                    <label className="upload_image no_radius v2">
                      <Input
                        sx={{ display: "none" }}
                        type="file"
                        inputProps={{ accept: "image/*" }}
                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                          const files = event.target.files;
                          if (files && files[0]) {
                            setShowroomImage(URL.createObjectURL(files[0]));
                          }
                        }}
                      />
                      <span className="upload_image_holder">
                        <figure className="add_img">
                          <img src="/static/images/placeholder.png" alt="" />
                          <span className="upload_img_icon">
                            <img src="/static/images/edit2_icon.svg" alt="" />
                          </span>
                        </figure>
                      </span>
                    </label>
                  )}
                </div>
              </div>
            </div>

            {/* Showroom Name */}
            <div className="control_group w_50">
              <label>Showroom Name</label>
              <TextField placeholder="Enter Showroom Name" hiddenLabel fullWidth />
            </div>

            {/* Location */}
            <div className="control_group w_50">
              <label>Showroom Location</label>
              <TextField placeholder="Enter Location" hiddenLabel fullWidth />
            </div>

            {/* Registered Address */}
            <div className="control_group w_100">
              <label>Showroom Registered Address</label>
              <TextField
                placeholder="Enter Registered Address"
                hiddenLabel
                fullWidth
                multiline
                rows={3}
              />
            </div>

            <div className="control_group w_50">
              <div className="gap_p">
                {/* Opening Time */}
                <div className="control_group w_50">
                  <label>Opening Time</label>
                  <TextField type="time" hiddenLabel fullWidth />
                </div>

                {/* Closing Time */}
                <div className="control_group w_50">
                  <label>Closing Time</label>
                  <TextField type="time" hiddenLabel fullWidth />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="table_header">
            <h2>Owner Information</h2>
          </div>
          <div className="gap_p">
            {/* Logo Upload */}
            <div className="control_group w_33">
              <label>Dealer Logo</label>
              {logo ? (
                <div className="upload_image no_radius v2">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={logo} />
                    </figure>
                    <CloseIcon
                      className="remove_img"
                      onClick={() => setLogo("")}
                    />
                  </div>
                </div>
              ) : (
                <label className="upload_image no_radius v2">
                  <Input
                    sx={{ display: "none" }}
                    type="file"
                    inputProps={{ accept: "image/*" }}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      const files = event.target.files;
                      if (files && files[0]) {
                        setLogo(URL.createObjectURL(files[0]));
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img src="/static/images/placeholder.png" alt="" />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>

            {/* Owner Name */}
            <div className="control_group w_100">
              <label>Owner / Dealer Name</label>
              <TextField placeholder="Enter Owner Name" hiddenLabel fullWidth />
            </div>

            {/* Email */}
            <div className="control_group w_33">
              <label>Email</label>
              <TextField type="email" placeholder="Enter Email" hiddenLabel fullWidth />
            </div>

            {/* Phone */}
            <div className="control_group w_33">
              <label>Phone Number</label>
              <PhoneInput
                country="in"
                placeholder="Enter Phone Number"
                inputStyle={{ width: "100%" }}
              />
            </div>

            {/* Phone */}
            <div className="control_group w_33">
              <label>Whatsapp Number</label>
              <PhoneInput
                country="in"
                placeholder="Enter Whatsapp Number"
                inputStyle={{ width: "100%" }}
              />
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="table_header">
            <h2>Upload Documents</h2>
          </div>
          <div className="gap_p">
            {/* Owner ID Proof */}
            <div className="control_group w_50">
              <label>Owner ID Proof</label>
              <div className="upload_box">
                <label className="upload_action">
                  <input type="file" />
                  <FileUploadOutlinedIcon />
                  <p>Upload ID Proof</p>
                </label>
              </div>
            </div>

            {/* Business Documents */}
            <div className="control_group w_50">
              <label>Business / Showroom Documents</label>
              <div className="upload_box">
                <label className="upload_action">
                  <input type="file" />
                  <FileUploadOutlinedIcon />
                  <p>Upload Business/Showroom Documents</p>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="table_header">
            <h2>Further details</h2>
          </div>
          <div className="gap_p">
            <div className="control_group w_100">
              <label>Please select the language</label>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                className="flex"
              >
                <FormControlLabel value="female" control={<Radio />} label="English" />
                <FormControlLabel value="male" control={<Radio />} label="Arabic" />
              </RadioGroup>
            </div>

            {/* Description */}
            <div className="control_group w_100">
              <label>Description</label>
              <TextField
                placeholder="Enter Description"
                hiddenLabel
                fullWidth
                multiline
                rows={4}
              />
            </div>
          </div>
        </div>

        {/* SAVE BUTTON */}
        <div className="form_btn">
          <Button className="btn btn_primary">Save</Button>
        </div>
      </div>
    </>
  );
};

export default AddEditDealer;